import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/company/laboratory/new',
  title: 'Cadastrar Laboratório',
  endpoint: '/app/company',
}
